import { Mic2 } from "lucide-react";

/**
 * Browser-native audio keeps the sample streamable from the static host and
 * avoids coupling marketing pages to the private phone/TTS websocket.
 */
export default function VoiceSamplePlayer({
  src,
  title,
  description,
  dark = false,
  testId,
}) {
  return (
    <div
      className={`rounded-lg border p-5 ${
        dark
          ? "border-background/15 bg-background/[0.07] text-background"
          : "border-border bg-card"
      }`}
    >
      <div className="flex items-start gap-3 mb-4">
        <div className="w-9 h-9 rounded-lg bg-primary/15 text-primary grid place-items-center shrink-0">
          <Mic2 className="w-4 h-4" aria-hidden="true" />
        </div>
        <div>
          <p className={`text-sm font-bold ${dark ? "text-background" : "text-foreground"}`}>
            {title}
          </p>
          <p className={`text-xs leading-relaxed mt-1 ${dark ? "text-background/65" : "text-muted-foreground"}`}>
            {description}
          </p>
        </div>
      </div>
      <audio
        data-testid={testId}
        controls
        controlsList="nodownload"
        onContextMenu={(event) => event.preventDefault()}
        preload="none"
        playsInline
        className="w-full"
        aria-label={title}
      >
        <source src={src} type="audio/wav" />
        Your browser does not support audio playback.
      </audio>
    </div>
  );
}
